import { partial } from 'es-toolkit';
import { PREPOPULATE_SEARCH_GUIDE_ID } from '../../constants';
import { transformGuideItem } from './transforms';
const profileGuideIdRegex = /^[spt]\d+$/;
export class UIService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    get(options) {
        const { guideId, contextGuideId, params } = options;
        const { domains, uiServiceOptions } = this.#storeClient.options;
        const profileUrl = `${domains.api}/profiles/${options.guideId}/contents`;
        const categoryUrl = `${domains.api}/categories/${guideId}`;
        const finalCategoryUrl = contextGuideId
            ? `${categoryUrl}/${contextGuideId}`
            : categoryUrl;
        const url = profileGuideIdRegex.test(guideId)
            ? profileUrl
            : finalCategoryUrl;
        const transform = partial(transformGuideItem, partial.placeholder, contextGuideId || guideId, uiServiceOptions.generateRoutePathForGuideItem);
        return this.#requestClient.fetch({ url, transform, params });
    }
    search(params) {
        const finalQuery = params.isPrepopulateSearch
            ? this.#storeClient.getConfigSetting(PREPOPULATE_SEARCH_GUIDE_ID)
            : params.query;
        if (!finalQuery) {
            throw new Error(params.isPrepopulateSearch
                ? 'Missing Pre-Populate Search Guide ID from Config Settings'
                : 'Query is required for search');
        }
        const { domains, uiServiceOptions } = this.#storeClient.options;
        return this.#requestClient.fetch({
            url: `${domains.api}/profiles`,
            params: {
                ...params,
                fullTextSearch: !params.isPrepopulateSearch,
                query: finalQuery,
            },
            transform: partial(transformGuideItem, partial.placeholder, '', uiServiceOptions.generateRoutePathForGuideItem),
        });
    }
}
